module.exports = __webpack_public_path__ + "static/history-stage-nov-2019-903cba85e9e279e4aa0c5ce5f06f9c54.webp";